var lt = {
  "Add Upsell.com to your ": "Pridėkite Upsell.com prie savo ",
  "All time": "Visą laiką",
  "and select": "ir pasirinkite",
  "button": "mygtuką",
  "Cart drawer page": "Krepšelio stalčiaus puslapis",
  "Cart page": "Krepšelio puslapis",
  "Check status": "Patikrinti būseną",
  "Checkout page": "Atsiskaitymo puslapis",
  "Click": "Spustelėkite",
  "Click on": "Spustelėkite",
  "Click the": "Spustelėkite",
  "Custom slot": "Pasirinktinis lizdas",
  "Custom slots": "Pasirinktiniai lizdai",
  "Custom Slots": "Pasirinktiniai lizdai",
  "contact support.": "susisiekite su palaikymo komanda.",
  "from the right sidebar": "iš dešinės šoninės juostos",
  "Go to your Cart drawer page": "Eikite į Krepšelio stalčiaus puslapį",
  "Go to your Cart page": "Eikite į Krepšelio puslapį",
  "Go to your Checkout page": "Eikite į Atsiskaitymo puslapį",
  "Go to your Order status page": "Eikite į Užsakymo būsenos puslapį",
  "Go to your Post purchase page": "Eikite į Puslapį po pirkimo",
  "Go to your Product page": "Eikite į Produkto puslapį",
  "Go to your Thank you page": "Eikite į Padėkos puslapį",
  "items": "prekės",
  "in the left sidebar": "kairėje šoninėje juostoje",
  "Last 12 months": "Paskutiniai 12 mėnesių",
  "Last 30 days": "Paskutinės 30 dienų",
  "Last 365 days": "Paskutinės 365 dienos",
  "Last 7 days": "Paskutinės 7 dienos",
  "Last 90 days": "Paskutinės 90 dienų",
  "Last month": "Praėjusį mėnesį",
  "Last year": "Praėjusiais metais",
  "Make sure": "Įsitikinkite, kad",
  "Need assistance? Contact our support team for help.": "Reikia pagalbos? Susisiekite su mūsų palaikymo komanda.",
  "Order status page": "Užsakymo būsenos puslapis",
  "Our app is currently undergoing a bit of magic to enhance your experience.": "Mūsų programėlė šiuo metu atnaujinama, kad pagerintume jūsų patirtį.",
  "Post purchase page": "Puslapis po pirkimo",
  "Product page": "Produkto puslapis",
  "Save": "Išsaugoti",
  "Scroll to the bottom and select": "Slinkite į apačią ir pasirinkite",
  "Select": "Pasirinkti",
  "Success. Please continue.": "Sėkmė. Prašome tęsti.",
  "Thank you page": "Padėkos puslapis",
  "The Upsell.com team.": "Upsell.com komanda.",
  "The Upsell.com widget is not placed on ": "Upsell.com valdiklis nėra patalpintas ",
  ". Please follow the steps above or ": " puslapyje. Prašome sekti aukščiau pateiktus žingsnius arba ",
  "Today": "Šiandien",
  "toggle is on": "jungiklis įjungtas",
  "Total": "Iš viso",
  "under": "po",
  "We apologize for any inconvenience caused,": "Atsiprašome už nepatogumus,",
  "We apologize for any inconvenience caused.": "Atsiprašome už nepatogumus.",
  "We'll be done in a few minutes!": "Baigsime už kelių minučių!",
  "We're improving our services!": "Tobuliname savo paslaugas!",
  "Widget already added": "Valdiklis jau pridėtas",
  "Yesterday": "Vakar",
  "You placed the widget on the ": "Jūs patalpinote valdiklį ",
  ", but you didn't save it in Shopify editor. Please go back to ": " puslapyje, bet neišsaugojote jo Shopify redaktoriuje. Prašome grįžti į ",
  " and save the changes.": " ir išsaugoti pakeitimus."
};

export { lt as default };
//# sourceMappingURL=lt.json.js.map
